import {useMutation, useQueryClient} from '@tanstack/react-query';

import {addOnboardingGeoConfig, AddOnboardingGeoConfigParams} from '../api';
import {QUERY__ONBOARDING, QUERY__ONBOARDINGS} from '../queryKeys';

export const useAddOnboardingGeoConfig = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (params: AddOnboardingGeoConfigParams) =>
      addOnboardingGeoConfig(params),
    onSuccess: (_, {type}) => {
      void queryClient.invalidateQueries({queryKey: [QUERY__ONBOARDINGS]});
      void queryClient.invalidateQueries({
        queryKey: [QUERY__ONBOARDING, type],
      });
    },
  });
};
